import React from "react";
import ArtistFilter from "components/filters/Filters/ArtistFilter";
import ContactFitler from "components/filters/Filters/ContactFilter";
import ProductionFilter from "components/filters/Filters/ProductionFilter";
import VenueFilter from "components/filters/Filters/VenueFilter";
import AppointmentPhaseFilter from "components/filters/Filters/AppointmentPhaseFilter";
import AppointmentTypeFilter from "components/filters/Filters/AppointmentTypeFilter";
import { PlannerSortFilter } from "components/filters/Filters/SortFilter";
import MonthFilter from "components/filters/Filters/MonthFilter";

interface MonthFilterProps {
  external?: boolean;
}

export const MonthFilters = (props: MonthFilterProps) => {
  return <>
    <ArtistFilter />
    {!props.external && <ContactFitler />}
    <ProductionFilter />
    {(site.currentEnvironment.venueFilterInMonthViewEnabled && site.permissions.addressBook.canAccess) && <VenueFilter />}
    <AppointmentPhaseFilter />
    <AppointmentTypeFilter />
    <MonthFilter />
    <PlannerSortFilter />
  </>;
};
